module.exports = __webpack_public_path__ + "img/battery-damaged.94bb65d8.svg";